import {
  doDelete,
  doGet,
  doPost,
  doPut,
  doPutFileUpload,
  EndpointBuilder,
  toPaginatedURL
} from '../../helpers';
import { Agency, AgencySearchResult } from '../../../../models/agency/Agency';
import { IdentifierDTO } from '@zazume/zzm-base';
import { PaginationOptions } from '../../../../hooks';
import { EditAgencyFormValues } from '#/pages/agencies/components/modals/EditAgency.schema';
import { User } from '#/models';

export const agencies = {
  list: (params?: EndpointBuilder) => (pagination: PaginationOptions) => () =>
    doGet<Agency[]>(toPaginatedURL(`/dashboard/agencies${params ? params.queryParams : ''}`, pagination)),
  searchByName: (name: string) => () =>
    doGet<AgencySearchResult[]>(`/dashboard/agencies/search?name=${name}`),
  get: (agencyId: IdentifierDTO) => () =>
    doGet<Agency>(`/dashboard/agencies/${agencyId}`),
  create: () => (body: any) =>
    doPost<IdentifierDTO>('/dashboard/agencies/create', body),
  update: (agencyId: IdentifierDTO) => (body: EditAgencyFormValues) =>
    doPut<IdentifierDTO>(`/dashboard/agencies/${agencyId}`, body),
  replaceAdmin: (agencyId: IdentifierDTO) => (agentId: IdentifierDTO) =>
    doPut(`/dashboard/agencies/${agencyId}/admin/${agentId}`),
  listAgents: (agencyId: IdentifierDTO) => () =>
    doGet<User[]>(`/dashboard/agencies/${agencyId}/agents`),
  assignAgent: (agencyId: IdentifierDTO) => (agentId: IdentifierDTO) =>
    doPut(`/dashboard/agencies/${agencyId}/agents/${agentId}`),
  removeAgent: (agencyId: IdentifierDTO) => (agentId: IdentifierDTO) =>
    doDelete(`/dashboard/agencies/${agencyId}/agents/${agentId}`),
  uploadLogo: (agencyId: IdentifierDTO) => (formData: FormData) =>
    doPutFileUpload<Agency>(`/dashboard/agencies/${agencyId}/logo`, formData),
  uploadLogoIcon: (agencyId: IdentifierDTO) => (formData: FormData) =>
    doPutFileUpload<Agency>(`/dashboard/agencies/${agencyId}/logo-icon`, formData),
  delete: (agencyId: IdentifierDTO) =>
    doDelete<void>(`/dashboard/agencies/${agencyId}`)
};
